import { render, staticRenderFns } from "./customersTextFields.vue?vue&type=template&id=089bee24&scoped=true&"
import script from "./customersTextFields.vue?vue&type=script&lang=js&"
export * from "./customersTextFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089bee24",
  null
  
)

export default component.exports